export function getUtmFromCookie(): Record<string, string> | null {
    try {
        const cookies = document.cookie.split(";");
        for (const cookie of cookies) {
            const trimmed = cookie.trim();
            const eqIndex = trimmed.indexOf("=");
            if (eqIndex === -1) continue;
            const name = trimmed.substring(0, eqIndex);
            const value = trimmed.substring(eqIndex + 1);
            if (name === "cookie_utms" && value) {
                return JSON.parse(decodeURIComponent(value));
            }
        }
    } catch (e) {
        // Fail silently if cookie parsing fails
    }
    return null;
}
